import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';
import classnames from 'classnames';

import './style.scss';

const Partner = ({ title, link, subTitle, linkTitle, className, image, imageAlt }) => (
  <div className={classnames(className, 'Partner')}>
    <span className="Partner__subTitle">{subTitle}</span>
    { image && (
      <div className="Partner__details__avatar"><img alt={imageAlt} src={image} /></div>
    )}
    <h3 className="Partner__title asH4">{ title }</h3>
    { link && (
      <CoreLink to={link} className="underline-on-hover font-normal">
        <span className="Partner__link">{linkTitle}<i className="icon icon-after icon-chevron-right" /></span>
      </CoreLink>
    )}
  </div>
);

export default Partner;
